// hi印地语
export default {
    CustomSelect: {
        '请选择': 'चुनें',
    },
    TopNav: {
        '创作者': 'निर्माता',
        '游客': 'अतिथि',
        '请登录后体验完整功能': 'पूर्ण कार्यक्षमता के लिए कृपया लॉगिन करें',
        '登录': 'लॉगिन करें',
        '免费试用': 'मुफ्त ट्रायल',
        '退出登录': 'लॉगआउट करें',
        '个人中心': 'मेरा खाता',
        '我的视频': 'मेरे वीडियो',
        '额度管理': 'क्रेडिट प्रबंधन',
        '首页': 'होम',
        'AI创作': 'एआई निर्माण',
        '多参考': 'बहु-संदर्भ',
        '文本视频': 'टेक्स्ट से वीडियो',
        '图片视频': 'छवि से वीडियो',
        '文生图': 'टेक्स्ट से छवि',
        '图生图': 'छवि से छवि',
        '会员中心': 'सदस्यता केंद्र',
        '概览': 'अवलोकन',
        '我的创作': 'मेरी रचनाएँ',
        '账单管理': 'बिल प्रबंधन',
        '生成任务': 'जनरेशन कार्य',
        '价格': 'कीमतें',
        '新闻资讯': 'समाचार',
        '确定要退出登录吗？': 'क्या आप लॉगआउट करना चाहते हैं?',
        '提示': 'संकेत',
        '确定': 'पुष्टि करें',
        '取消': 'रद्द करें',
        '退出成功': 'सफलतापूर्वक लॉगआउट',
        '视频展示': 'वीडियो प्रदर्शन'
    },
    AiLayout: {
        'AI创作中心': 'एआई निर्माण केंद्र',
        '视频生成': 'वीडियो जनरेशन',
        '图片生成': 'छवि जनरेशन',
        '我的作品': 'मेरी कृतियाँ',
        '我的创作': 'मेरी रचनाएँ',
        '今日剩余额度': 'आज शेष क्रेडिट',
        '多参考': 'बहु-संदर्भ',
        '文本视频': 'टेक्स्ट से वीडियो',
        '图片视频': 'छवि से वीडियो',
        '文生图': 'टेक्स्ट से छवि',
        '图生图': 'छवि से छवि',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'अगली पीढ़ी का एआई वीडियो जनरेशन प्लेटफॉर्म, विचारों को तुरंत वास्तविकता में बदलें',
        '产品': 'उत्पाद',
        'AI视频': 'एआई वीडियो',
        '价格方案': 'मूल्य योजनाएँ',
        '新闻资讯': 'समाचार',
        '支持': 'सहायता',
        '帮助中心': 'सहायता केंद्र',
        'API文档': 'एपीआई दस्तावेज़',
        '常见问题': 'सामान्य प्रश्न',
        '法律': 'कानूनी',
        '服务条款': 'सेवा की शर्तें',
        '隐私政策': 'गोपनीयता नीति',
        '使用协议': 'उपयोग समझौता',
        '版权所有': 'सर्वाधिकार सुरक्षित',
        '客服邮箱': 'सहायता ईमेल',
        '复制邮箱': 'ईमेल कॉपी करें',
        '开发中': 'विकासाधीन, बने रहें!',
        '链接已复制到剪贴板': 'लिंक क्लिपबोर्ड पर कॉपी किया गया',
    },
    MyLayout: {
        '创作者': 'निर्माता',
        '退出登录': 'लॉगआउट करें',
        '概览': 'अवलोकन',
        '我的创作': 'मेरी रचनाएँ',
        '会员中心': 'सदस्यता केंद्र',
        '额度管理': 'क्रेडिट प्रबंधन',
        '账单管理': 'बिल प्रबंधन',
        '生成任务': 'जनरेशन कार्य',
        '确定要退出登录吗？': 'क्या आप लॉगआउट करना चाहते हैं?',
        '提示': 'संकेत',
        '确定': 'पुष्टि करें',
        '取消': 'रद्द करें',
        '退出成功': 'सफलतापूर्वक लॉगआउट'
    },
    Image: {
        "文本生成图片": "टेक्स्ट से छवि",
        "图片生成图片": "छवि से छवि",
        "用文字描述": "अपनी इच्छा का वर्णन शब्दों में करें",
        "上传图片素材": "छवि सामग्री अपलोड करें, बहु-छवि जनरेशन समर्थित",
        "图片描述": "छवि विवरण",
        "描述您想要的图片": "वांछित छवि की सामग्री का विस्तार से वर्णन करें, हिंदी या अंग्रेजी में...",
        "提示描述越详细效果越好": "संकेत: विवरण जितना अधिक विस्तृत होगा, जनरेशन परिणाम उतना ही बेहतर होगा",
        "图片素材": "छवि सामग्री",
        "预览图片": "पूर्वावलोकन",
        "上传图片": "छवि अपलोड करें",
        "支持格式JPGPNG": "JPG, PNG प्रारूपों का समर्थन करता है",
        "最多": "अधिकतम",
        "张图片": "छवि(याँ)",
        "超过大小限制": "10 एमबी की सीमा से अधिक",
        "不是图片文件": "अमान्य छवि फ़ाइल",
        "最多上传": "अधिकतम अपलोड",
        "请先上传图片": "कृपया पहले छवि सामग्री अपलोड करें",
        "请选择要生成的图片": "कृपया जनरेट करने के लिए छवि चुनें",
        "生成结果": "जनरेशन परिणाम",
        "重新生成成功": "पुनः जनरेशन सफल",
        "模型": "एआई मॉडल",
        "请选择模型": "कृपया जनरेशन मॉडल चुनें",
        "分辨率": "आउटपुट रिज़ॉल्यूशन",
        "请选择分辨率": "कृपया रिज़ॉल्यूशन चुनें",
        "图片比例": "छवि पहलू अनुपात",
        "补充描述": "अतिरिक्त विवरण (वैकल्पिक)",
        "补充描述提示": "वैकल्पिक: छवि में कोई अतिरिक्त प्रभाव या शैली शामिल करने का वर्णन करें",
        "开始绘制": "ड्राइंग शुरू करें",
        "开始生成": "जनरेशन शुरू करें",
        "生成中": "जनरेशन चल रहा है, कृपया प्रतीक्षा करें...",
        "生成成功": "जनरेशन सफल",
        "图片生成成功": "छवि सफलतापूर्वक जनरेट हुई!",
        "作品已保存到我的作品": "कृति 'मेरी कृतियाँ' में सहेजी गई है",
        "继续创作": "निर्माण जारी रखें",
        "查看作品": "कृति देखें",
        "请输入图片描述": "कृपया छवि विवरण दर्ज करें"
    },
    MyCreation: {
        '我的创作': 'मेरी रचनाएँ',
        '查看和管理您的所有作品': 'अपनी सभी कृतियाँ देखें और प्रबंधित करें',
        '预览': 'पूर्वावलोकन',
        '下载': 'डाउनलोड',
        '编辑': 'संपादित करें',
        '分享': 'साझा करें',
        '删除': 'हटाएँ',
        '暂无作品': 'कोई कृति नहीं',
        '去创作': 'निर्माण करें',
        '确定删除': 'हटाने की पुष्टि करें',
        '确定要删除作品': 'क्या आप कृति हटाना चाहते हैं',
        '吗？': '?',
        '此操作不可恢复': 'यह क्रिया अपरिवर्तनीय है, कृपया सावधानी बरतें!',
        '取消': 'रद्द करें',
        '分享作品': 'कृति साझा करें',
        '复制链接': 'लिंक कॉपी करें',
        '全部': 'सभी',
        '视频': 'वीडियो',
        '图片': 'छवि',
        '正在下载:': 'डाउनलोड हो रहा है: ',
        '链接已复制到剪贴板': 'लिंक क्लिपबोर्ड पर कॉपी किया गया',
        '删除成功': 'सफलतापूर्वक हटाया गया'
    },
    Video: {
        "文本生成视频": "टेक्स्ट से वीडियो",
        "图片生成视频": "छवि से वीडियो",
        "智能视频生成": "बुद्धिमान वीडियो जनरेशन",
        "输入文字描述": "टेक्स्ट विवरण दर्ज करें",
        "上传1-9张图片": "1-9 छवियाँ अपलोड करें",
        "上传图片视频音频": "छवि/वीडियो/ऑडियो अपलोड करें",
        "视频描述": "वीडियो विवरण",
        "描述您想要的视频场景": "वांछित वीडियो दृश्य का वर्णन करें",
        "提示": "संकेत",
        "图片素材": "छवि सामग्री",
        "最多上传": "अधिकतम अपलोड",
        "张": "छवि(याँ)",
        "预览": "पूर्वावलोकन",
        "上传图片": "छवि अपलोड करें",
        "支持格式": "JPG, PNG प्रारूप, प्रति फ़ाइल अधिकतम 10 एमबी, अधिकतम",
        "AI": "एआई बुद्धिमानी से एकीकृत करता है और सहज ट्रांज़िशन प्रभाव उत्पन्न करेगा",
        "动态描述": "गति विवरण",
        "描述您希望图片如何动起来": "वर्णन करें कि आप छवि को कैसे गतिमान देखना चाहते हैं",
        "个": "आइटम",
        "上传视频": "वीडियो अपलोड करें",
        "上传音频": "ऑडियो अपलोड करें",
        "描述您希望视频呈现的效果": "वांछित वीडियो प्रभाव का वर्णन करें",
        "模型": "मॉडल",
        "请选择模型": "कृपया मॉडल चुनें",
        "分辨率": "रिज़ॉल्यूशन",
        "请选择分辨率": "कृपया रिज़ॉल्यूशन चुनें",
        "宽高比": "पहलू अनुपात",
        "视频时长": "वीडियो अवधि",
        "生成音频": "ऑडियो जनरेट करें",
        "开启音效": "ध्वनि प्रभाव सक्षम करें",
        "静音模式": "म्यूट मोड",
        "音频提示": "संकेत: अपलोड किया गया ऑडियो पृष्ठभूमि संगीत के रूप में उपयोग किया जाएगा, यदि कोई ऑडियो अपलोड नहीं किया गया तो एआई स्वचालित रूप से संगीत जनरेट करेगा",
        "开始生成": "जनरेशन शुरू करें",
        "积分": "क्रेडिट",
        "生成中": "जनरेशन चल रहा है",
        "生成成功": "जनरेशन सफल",
        "视频生成成功！": "वीडियो सफलतापूर्वक जनरेट हुआ!",
        "作品已保存到": "कृति 'मेरी कृतियाँ' में सहेजी गई है",
        "继续创作": "निर्माण जारी रखें",
        "查看作品": "कृति देखें",
        "视频预览": "वीडियो पूर्वावलोकन",
        "关闭": "बंद करें",
        "下载视频": "वीडियो डाउनलोड करें",
        "您的浏览器不支持视频播放": "आपका ब्राउज़र वीडियो प्लेबैक का समर्थन नहीं करता",
        "生成进度": "जनरेशन प्रगति",
        "描述": "विवरण",
        "时长": "अवधि",
        "秒": "सेकंड",
        "视频素材": "वीडियो सामग्री",
        "音频素材": "ऑडियो सामग्री",
        "双图融合模式": "दोहरी छवि फ़्यूज़न मोड",
        "开始下载视频": "वीडियो डाउनलोड शुरू करें",
        "请输入视频描述": "कृपया वीडियो विवरण दर्ज करें",
        "请至少上传一张图片": "कृपया कम से कम एक छवि अपलोड करें",
        "请至少上传一张图片或一个视频": "कृपया कम से कम एक छवि या एक वीडियो अपलोड करें",
        "最多只能上传": "अधिकतम अपलोड",
        "超过": "से अधिक",
        "限制": "सीमा",
        "不是图片文件": "मान्य छवि फ़ाइल नहीं है",
        "不是视频文件": "मान्य वीडियो फ़ाइल नहीं है",
        "不是音频文件": "मान्य ऑडियो फ़ाइल नहीं है"
    },
    Forgot: {
        "找回密码": "पासवर्ड पुनर्प्राप्त करें",
        "请输入您的邮箱，我们将发送验证码": "कृपया अपना ईमेल दर्ज करें, हम एक सत्यापन कोड भेजेंगे",
        "密码重置成功，请使用新密码登录": "पासवर्ड सफलतापूर्वक रीसेट, कृपया नए पासवर्ड से लॉगिन करें",
        "密码重置成功": "पासवर्ड सफलतापूर्वक रीसेट",
        "您的密码已成功重置，请使用新密码登录": "आपका पासवर्ड सफलतापूर्वक रीसेट हो गया है, कृपया अपने नए पासवर्ड से लॉगिन करें",
        "立即登录": "अभी लॉगिन करें",
        "邮箱": "ईमेल",
        "请输入注册邮箱": "कृपया पंजीकृत ईमेल दर्ज करें",
        "发送验证码": "सत्यापन कोड भेजें",
        "请输入验证码": "कृपया सत्यापन कोड दर्ज करें",
        "验证码": "सत्यापन कोड",
        "新密码": "नया पासवर्ड",
        "设置新密码": "नया पासवर्ड सेट करें",
        "确认新密码": "नए पासवर्ड की पुष्टि करें",
        "再次输入新密码": "नया पासवर्ड फिर से दर्ज करें",
        "重置密码": "पासवर्ड रीसेट करें",
        "返回登录": "लॉगिन पर वापस जाएँ",
        "验证中": "सत्यापन हो रहा है",
        "重置中": "रीसेट हो रहा है",
        "弱": "कमजोर",
        "中": "मध्यम",
        "强": "मजबूत",
        "请输入邮箱地址": "कृपया ईमेल पता दर्ज करें",
        "请输入正确的邮箱格式": "कृपया मान्य ईमेल प्रारूप दर्ज करें",
        "验证码应为6位数字": "सत्यापन कोड 6 अंकों का होना चाहिए",
        "请输入新密码": "कृपया नया पासवर्ड दर्ज करें",
        "密码至少需要6位": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
        "请再次输入新密码": "कृपया नया पासवर्ड फिर से दर्ज करें",
        "两次输入的密码不一致": "दर्ज किए गए पासवर्ड मेल नहीं खाते",
        "验证码已发送": "सत्यापन कोड भेज दिया गया है"
    },
    Login: {
        "下一代AI视频生成平台": "अगली पीढ़ी का एआई वीडियो जनरेशन प्लेटफॉर्म",
        "一键生成": "वन-क्लिक जनरेशन",
        "支持4K超高清输出": "4K अल्ट्रा एचडी आउटपुट का समर्थन करता है",
        "多种风格模板任选": "कई शैली टेम्पलेट्स में से चुनें",
        "商用授权无忧使用": "व्यावसायिक लाइसेंस, बिना किसी चिंता के उपयोग करें",
        "欢迎回来": "वापसी पर स्वागत है",
        "登录您的账号继续创作": "निर्माण जारी रखने के लिए अपने खाते में लॉगिन करें",
        "邮箱": "ईमेल",
        "请输入邮箱地址": "कृपया ईमेल पता दर्ज करें",
        "密码": "पासवर्ड",
        "请输入您的密码": "कृपया अपना पासवर्ड दर्ज करें",
        "记住我": "मुझे याद रखें",
        "忘记密码？": "पासवर्ड भूल गए?",
        "登录": "लॉगिन करें",
        "登录中": "लॉगिन हो रहा है",
        "还没有账号？": "अभी तक कोई खाता नहीं?",
        "立即注册": "अभी पंजीकरण करें",
        "请输入正确的邮箱格式": "कृपया मान्य ईमेल प्रारूप दर्ज करें",
        "请输入密码": "कृपया पासवर्ड दर्ज करें",
        "密码至少需要6位": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
        "密码不能超过20位": "पासवर्ड 20 अक्षरों से अधिक नहीं हो सकता",
        "登录成功": "सफलतापूर्वक लॉगिन किया"
    },
    Register: {
        "创建账号": "खाता बनाएँ",
        "开始您的AI视频创作之旅": "अपनी एआई वीडियो निर्माण यात्रा शुरू करें",
        "姓名": "नाम",
        "请输入您的姓名": "कृपया अपना नाम दर्ज करें",
        "邮箱": "ईमेल",
        "请输入邮箱地址": "कृपया ईमेल पता दर्ज करें",
        "获取验证码": "सत्यापन कोड प्राप्त करें",
        "验证码": "सत्यापन कोड",
        "请输入验证码": "कृपया सत्यापन कोड दर्ज करें",
        "密码": "पासवर्ड",
        "设置密码": "पासवर्ड सेट करें",
        "确认密码": "पासवर्ड की पुष्टि करें",
        "再次输入密码": "पासवर्ड फिर से दर्ज करें",
        "我已阅读并同意": "मैंने पढ़ लिया है और मैं सहमत हूँ",
        "服务条款": "सेवा की शर्तें",
        "和": "और",
        "隐私政策": "गोपनीयता नीति",
        "注册中": "पंजीकरण हो रहा है",
        "已有账号？": "पहले से खाता है?",
        "立即登录": "अभी लॉगिन करें",
        "弱": "कमजोर",
        "中": "मध्यम",
        "强": "मजबूत",
        "请输入姓名": "कृपया नाम दर्ज करें",
        "姓名至少需要2个字符": "नाम कम से कम 2 अक्षरों का होना चाहिए",
        "姓名不能超过20个字符": "नाम 20 अक्षरों से अधिक नहीं हो सकता",
        "请输入正确的邮箱格式": "कृपया मान्य ईमेल प्रारूप दर्ज करें",
        "验证码应为6位数字": "सत्यापन कोड 6 अंकों का होना चाहिए",
        "请输入密码": "कृपया पासवर्ड दर्ज करें",
        "密码至少需要6位": "पासवर्ड कम से कम 6 अक्षरों का होना चाहिए",
        "密码不能超过20位": "पासवर्ड 20 अक्षरों से अधिक नहीं हो सकता",
        "请再次输入密码": "कृपया पासवर्ड फिर से दर्ज करें",
        "两次输入的密码不一致": "दर्ज किए गए पासवर्ड मेल नहीं खाते",
        "验证码已发送": "सत्यापन कोड भेज दिया गया है",
        "注册成功": "पंजीकरण सफल"
    },
    Faq: {
        '常见问题': 'सामान्य प्रश्न',
        '您在使用过程中遇到的问题': 'उपयोग के दौरान आने वाली समस्याओं के समाधान यहाँ खोजें',
        '搜索您的问题': 'अपना प्रश्न खोजें...',
        '没有找到相关的问题': 'कोई संबंधित प्रश्न नहीं मिला',
        '查看全部问题': 'सभी प्रश्न देखें',
        '没有找到您想要的答案？': 'आपको वांछित उत्तर नहीं मिला?',
        '我们的客服团队随时为您提供帮助': 'हमारी सहायता टीम आपकी मदद के लिए हमेशा उपलब्ध है',
        '复制客服邮箱': 'सहायता ईमेल कॉपी करें',
        '链接已复制到剪贴板': 'लिंक क्लिपबोर्ड पर कॉपी किया गया'
    },
    Home: {
        '立即订阅': 'अभी सब्सक्राइब करें',
        'AI视频生成新时代': 'एआई वीडियो जनरेशन का नया युग',
        '用文字创造': 'शब्दों से सृजन करें',
        '无限视频': 'असीमित वीडियो',
        '让每个人都能成为视频创作者': 'हर किसी को वीडियो निर्माता बनने में सक्षम बनाएं। बस एक टेक्स्ट विवरण दर्ज करें और उच्च गुणवत्ता, अद्वितीय एआई वीडियो प्राप्त करें।',
        '免费开始': 'मुफ्त शुरू करें',
        '观看演示': 'डेमो देखें',
        'AI生成': 'एआई जनरेशन',
        'AI视频': 'एआई वीडियो',
        '三步轻松生成专业视频': 'तीन चरणों में पेशेवर वीडियो आसानी से जनरेट करें',
        '输入提示词': 'प्रॉम्प्ट दर्ज करें',
        '用文字描述您想要的视频内容': 'अपनी वांछित वीडियो सामग्री का शब्दों में वर्णन करें, जितना अधिक विस्तृत होगा उतना बेहतर',
        '智能生成': 'बुद्धिमान जनरेशन',
        'AI模型自动理解并创作': 'एआई मॉडल स्वचालित रूप से समझता है और बनाता है, रेंडरिंग कुछ मिनटों में पूरी हो जाती है',
        '下载作品': 'कृति डाउनलोड करें',
        '高清视频生成完成': 'एचडी वीडियो जनरेशन पूर्ण, तुरंत डाउनलोड और उपयोग के लिए तैयार',
        'AI视频生成': 'एआई वीडियो जनरेशन',
        '精彩视频': 'टेक्स्ट विवरण दर्ज करें, एआई आपके लिए एक शानदार वीडियो जनरेट करेगा',
        '描述您想要的视频场景': 'अपनी वांछित वीडियो दृश्य का वर्णन करें, उदाहरण के लिए: एक बिल्ली चेरी ब्लॉसम के पेड़ के नीचे खेल रही है, सूरज की रोशनी पंखुड़ियों से होकर गिर रही है...',
        '生成中': 'जनरेशन चल रहा है...',
        '生成视频': 'वीडियो जनरेट करें',
        'AI图片': 'एआई छवि',
        '精美图片': 'टेक्स्ट विवरण दर्ज करें, एआई आपके लिए एक शानदार छवि जनरेट करेगा',
        '描述您想要的图片场景': 'अपनी वांछित छवि दृश्य का वर्णन करें, उदाहरण के लिए: भविष्य के शहर का क्षितिज, टिमटिमाती नियॉन लाइटें, साइबरपंक शैली...',
        '生成图片': 'छवि जनरेट करें',
        '强大功能': 'शक्तिशाली विशेषताएँ',
        '让视频创作变得简单有趣': 'वीडियो निर्माण को सरल और मनोरंजक बनाएँ',
        '案例展示': 'उदाहरण प्रदर्शन',
        '来看看用户使用': 'यहाँ देखें उपयोगकर्ताओं द्वारा बनाई गई शानदार कृतियाँ',
        '创作的精彩作品': 'उपयोगकर्ता',
        '新闻资讯': 'समाचार',
        '了解': 'जानें',
        '的最新动态和产品更新': 'नवीनतम समाचार और उत्पाद अपडेट',
        '查看更多': 'और देखें',
        '热门': 'लोकप्रिय',
        '最新': 'नवीनतम',
        '阅读更多': 'और पढ़ें',
        '选择适合您的方案': 'अपने लिए उपयुक्त योजना चुनें',
        '灵活的定价': 'विभिन्न आवश्यकताओं के लिए लचीली कीमतें',
        '视频预览': 'वीडियो पूर्वावलोकन',
        '生成成功': 'जनरेशन सफल',
        '作品已保存到': "कृति 'मेरी रचनाएँ' में सहेजी गई है",
        '继续创作': 'निर्माण जारी रखें',
        '查看作品': 'कृति देखें',
        '请输入视频描述': 'कृपया वीडियो विवरण दर्ज करें',
        '视频生成成功！': 'वीडियो सफलतापूर्वक जनरेट हुआ!',
        '请输入图片描述': 'कृपया छवि विवरण दर्ज करें',
        '图片生成成功！': 'छवि सफलतापूर्वक जनरेट हुई!',
    },
    News: {
        '新闻资讯': 'समाचार',
        '了解': 'जानें',
        '的最新动态和产品更新': 'नवीनतम समाचार और उत्पाद अपडेट',
        '精选': 'चयनित',
        '阅读': 'पढ़ें',
        '点赞': 'पसंद करें',
        '热门': 'लोकप्रिय',
        '最新': 'नवीनतम',
        '阅读更多': 'और पढ़ें',
        '加载中': 'लोड हो रहा है...',
        '暂无新闻': 'कोई समाचार नहीं',
        '清除筛选': 'फ़िल्टर साफ़ करें',
        '加载新闻失败': 'समाचार लोड करने में विफल, कृपया बाद में पुनः प्रयास करें',
    },
    Price: {
        '选择适合您的方案': 'अपने लिए उपयुक्त योजना चुनें',
        '灵活的定价': 'विभिन्न आवश्यकताओं के लिए लचीली कीमतें',
        '包月': 'मासिक',
        '包年': 'वार्षिक',
        '购买积分': 'क्रेडिट खरीदें',
        '只需要几个视频': 'केवल कुछ वीडियो चाहिए? कोई सदस्यता नहीं, सीधे क्रेडिट पैक खरीदें',
        '产品大全': 'उत्पाद सूची',
        '了解': 'जानें',
        '全系列产品的详细信息和支付方式': 'संपूर्ण उत्पाद श्रृंखला की विस्तृत जानकारी और भुगतान विधियाँ'
    },
    Billing: {
        '账单管理': 'बिल प्रबंधन',
        '账户余额': 'खाता शेष',
        '本月支出': 'इस माह का खर्च',
        '订单数量': 'ऑर्डरों की संख्या',
        '账单列表': 'बिल सूची',
        '请选择类型': 'कृपया प्रकार चुनें',
        '请选择时间范围': 'कृपया समय सीमा चुनें',
        '订单号': 'ऑर्डर संख्या',
        '类型': 'प्रकार',
        '金额': 'राशि',
        '状态': 'स्थिति',
        '时间': 'तिथि',
        '操作': 'कार्रवाई',
        '查看详情': 'विवरण देखें',
        '下载发票': 'इनवॉइस डाउनलोड करें',
        '暂无作品': 'कोई कृति नहीं',
        '去创作': 'निर्माण करें',
        '支付方式': 'भुगतान विधि',
        '添加支付方式': 'भुगतान विधि जोड़ें',
        '默认': 'डिफ़ॉल्ट',
        '设为默认': 'डिफ़ॉल्ट के रूप में सेट करें',
        '编辑': 'संपादित करें',
        '删除': 'हटाएँ',
        '账单详情': 'बिल विवरण',
        '交易流水号': 'लेनदेन संख्या',
        '关闭': 'बंद करें',
        '账号': 'खाता/कार्ड संख्या',
        '请输入账号或卡号': 'कृपया खाता या कार्ड संख्या दर्ज करें',
        '姓名': 'नाम',
        '请输入持卡人姓名': 'कृपया कार्डधारक का नाम दर्ज करें',
        '有效期': 'समाप्ति तिथि',
        '请输入CVV码': 'कृपया सीवीवी कोड दर्ज करें',
        '取消': 'रद्द करें',
        '确认添加': 'जोड़ने की पुष्टि करें',
        '确认修改': 'संशोधन की पुष्टि करें',
        '确认删除': 'हटाने की पुष्टि करें',
        "编辑支付方式": "भुगतान बदलें",
        "确定要删除支付方式": "भुगतान विधि हटाएँ?",
        "删除后不可恢复": "अपरिवर्तनीय!",
        "请输入账号": "नंबर लिखें",
        "添加成功": "जुड़ गया",
        "修改成功": "बदल गया",
        "已设为默认支付方式": "डिफ़ॉल्ट सेट हुआ",
        "删除成功": "हट गया",
    },
    Credit: {
        "额度管理": "क्रेडिट",
        "当前可用额度": "उपलब्ध",
        "升级会员": "अपग्रेड",
        "本月已用": "इस माह उपयोग",
        "视频生成": "वीडियो",
        "AI图片": "AI इमेज",
        "其他": "अन्य",
        "购买额度包": "पैकेज खरीदें",
        "最受欢迎": "सबसे लोकप्रिय",
        "额度": "क्रेडिट",
        "立即购买": "खरीदें",
        "使用记录": "इतिहास",
        "操作": "कार्य",
        "类型": "प्रकार",
        "额度变动": "बदलाव",
        "时间": "तारीख",
        "购买": "खरीदें",
        "确认购买": "पुष्टि करें",
        "金额": "राशि: ",
        "获得": "प्राप्त करें",
        "取消": "रद्द करें",
        "今天": "आज",
        "昨天": "कल",
    },
    Dashboard: {
        "欢迎回来": "वापसी पर स्वागत, निर्माता",
        "创建新视频": "नया वीडियो",
        "本月生成次数": "इस माह जनरेशन",
        "剩余额度": "शेष क्रेडिट",
        "总视频数": "कुल वीडियो",
        "会员状态": "सदस्यता स्थिति",
        "最近生成": "हालिया जनरेशन",
        "查看全部": "सभी देखें",
        "视频预览": "पूर्वावलोकन",
        "视频生成中": "जनरेशन हो रहा",
    },
    Membership: {
        "会员中心": "सदस्यता",
        "当前方案": "वर्तमान योजना",
        "Pro 会员": "Pro",
        "专业创作者首选": "पेशेवरों की पसंद",
        "月": "माह",
        "会员有效期": "वैधता",
        "剩余天数": "शेष दिन",
        "续费会员": "नवीनीकरण",
        "取消订阅": "रद्द करें",
        "本月使用情况": "मासिक उपयोग",
        "视频生成": "वीडियो",
        "次": "बार",
        "额度使用": "क्रेडिट उपयोग",
        "快速生成": "त्वरित जनरेशन",
        "升级方案": "अपग्रेड",
        "联系销售": "बिक्री से संपर्क करें",
        "会员权益": "लाभ",
        "续费后将延长会员有效期30天": "नवीनीकरण से 30 दिन बढ़ेंगे",
        "取消": "रद्द करें",
        "确认续费": "नवीनीकरण करें",
        "取消后您将失去所有会员权益": "लाभ खत्म, क्रेडिट रहेंगे",
        "再想想": "फिर सोचें",
        "确认取消": "पुष्टि",
        "姓名": "नाम",
        "请输入您的姓名": "नाम लिखें",
        "请输入姓名": "नाम लिखें",
        "公司": "कंपनी",
        "请输入公司名称": "कंपनी का नाम",
        "邮箱": "ईमेल",
        "请输入邮箱地址": "ईमेल लिखें",
        "请输入邮箱": "ईमेल लिखें",
        "请输入正确的邮箱格式": "ईमेल अमान्य",
        "需求": "आवश्यकताएँ",
        "请描述您的需求": "आवश्यकताएँ लिखें",
        "提交": "जमा करें",
        "请填写需求": "आवश्यकताएँ भरें",
        "续费成功": "नवीनीकरण हुआ!",
        "已取消订阅": "रद्द हुआ",
        "提交成功": "जमा हुआ, हम संपर्क करेंगे!",
    },
    Task: {
        "生成任务": "कार्य",
        "新建任务": "नया",
        "进行中": "जारी",
        "已完成": "पूरा हुआ",
        "失败": "विफल",
        "队列中": "कतार में",
        "活跃任务": "सक्रिय",
        "刷新": "ताज़ा करें",
        "暂无活跃任务": "कोई सक्रिय कार्य नहीं",
        "预计剩余": "शेष समय",
        "暂停": "रोकें",
        "继续": "फिर शुरू करें",
        "取消": "रद्द करें",
        "最近完成": "हालिया पूर्ण",
        "查看全部": "सभी देखें",
        "暂无完成的任务": "कोई पूर्ण कार्य नहीं",
        "播放": "चलाएँ",
        "下载": "डाउनलोड",
        "分享": "साझा करें",
        "确认取消": "पुष्टि",
        "确定要取消任务吗": "कार्य रद्द करें?",
        "已消耗的额度将无法退还": "क्रेडिट वापस नहीं मिलेंगे",
        "返回": "वापस",
        "分享作品": "साझा करें",
        "复制链接": "लिंक कॉपी करें",
        "任务列表已刷新": "ताज़ा हुआ",
        "已暂停": "रुका",
        "生成中": "जनरेशन",
        "已恢复": "फिर शुरू हुआ",
        "任务已取消": "रद्द हुआ",
        "链接已复制到剪贴板": "लिंक कॉपी हुआ",
    },
    VideoShow: {
        '示例': 'उदाहरण',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'हमारे डेमो लाइब्रेरी से सावधानीपूर्वक चुने गए क्लिप्स का एक संग्रह। समान शैली की सामग्री जेनरेट करना शुरू करने के लिए किसी भी कार्ड पर क्लिक करें।',
        '全部': 'सभी',
        '电影感': 'सिनेमाई',
        '角色': 'पात्र',
        '产品': 'उत्पाद',
        '自然': 'प्रकृति',
        '趣味': 'मनोरंजक',
        '加载中': 'लोड हो रहा है',
        '暂无展示': 'कोई डेमो उपलब्ध नहीं',
        '视频预览': 'वीडियो पूर्वावलोकन',
    },
    Request: {
        '加载中': 'लोड हो रहा है...',
        '您已退出登录': 'आप लॉग आउट हो चुके हैं, आप पुनः लॉग इन कर सकते हैं',
        '确认退出': 'लॉग आउट की पुष्टि करें',
        '重新登录': 'पुनः लॉग इन करें',
        '错误': 'त्रुटि',
        '网络错误': 'नेटवर्क त्रुटि',
        '下载中': 'डाउनलोड हो रहा है...'
    },
    Other: {
        '剩余额度': 'शेष राशि',
        '去登录': 'लॉग इन करें',
        '请登录后查看': 'कृपया देखने के लिए लॉग इन करें',
        '任务': 'कार्य',
        '可在「生成任务」中查看详情': '，विवरण "जनरेशन कार्य" में देखे जा सकते हैं',
        '查看详情': 'विवरण देखें',
        '排队中': 'कतार में',
        '运行中': 'चल रहा है',
        '取消': 'रद्द करें',
        '成功': 'सफल',
        '失败': 'विफल',
        '超时': 'समय समाप्त',
        '最后更新': 'अंतिम अद्यतन:',
        '视频生成': 'वीडियो जनरेशन',
        '活跃用户': 'सक्रिय उपयोगकर्ता',
        '用户评分': 'उपयोगकर्ता रेटिंग',
        '万': 'हजार',
        '快速生成': 'त्वरित जनरेशन',
        '先进的AI模型': 'उन्नत AI मॉडल, मिनटों में उच्च गुणवत्ता वाले वीडियो जनरेट करते हैं',
        '多种风格': 'विभिन्न शैलियाँ',
        '多种风格任您选择': 'यथार्थवादी, एनीमे, कलात्मक और अधिक शैलियाँ आपकी पसंद के लिए',
        '高清输出': 'हाई-डेफिनिशन आउटपुट',
        '支持4K超高清视频输出': '4K अल्ट्रा एचडी वीडियो आउटपुट का समर्थन करता है, विवरण स्पष्ट रूप से दिखाई देते हैं',
        '商用授权': 'व्यावसायिक लाइसेंस',
        '生成的视频可用于商业用途': 'जनरेट किए गए वीडियो का उपयोग व्यावसायिक उद्देश्यों के लिए किया जा सकता है, कॉपीराइट की कोई चिंता नहीं',
        '原价': 'मूल कीमत',
        '积分价格说明': 'क्रेडिट मूल्य स्पष्टीकरण',
        '系列': 'श्रृंखला',
        '模型': 'मॉडल',
        '分辨率': 'रिज़ॉल्यूशन',
        '积分': 'क्रेडिट',
        '秒': 'सेकंड',
        '秒示例': 'सेकंड (उदाहरण)',
        '图片模型': 'इमेज मॉडल',
        '图片为': 'इमेज है',
        '系列产品': 'श्रृंखला के उत्पाद, वर्तमान में समर्थित',
        '支持使用任意机型查看完整体验': '，पूर्ण अनुभव के लिए किसी भी डिवाइस का उपयोग करने का समर्थन करता है।',
        '计费方式': 'बिलिंग विधि',
        '张': 'छवि(याँ)',
        '按生成张数计费': 'जनरेट की गई छवियों की संख्या के अनुसार बिलिंग',
        '普通用户': 'सामान्य उपयोगकर्ता',
        '无记录': 'कोई रिकॉर्ड नहीं',
        '总支出': 'कुल व्यय',
        '月总使用': 'मासिक कुल उपयोग',
        '月视频使用': 'मासिक वीडियो उपयोग',
        '月图片使用': 'मासिक छवि उपयोग',
        '生成成功': 'जनरेशन सफल',
        '视频总生成': 'कुल वीडियो जनरेट',
        '图片总生成': 'कुल छवियाँ जनरेट',
        '生成中': 'जनरेशन हो रहा है, कृपया 1-3 मिनट प्रतीक्षा करें',
        '来自我们演示库的一套精心挑选的剪辑片段': 'हमारे डेमो लाइब्रेरी से सावधानीपूर्वक चयनित क्लिप का एक संग्रह।',
        '最近7天': 'पिछले 7 दिन',
        '最近30天': 'पिछले 30 दिन',
        '本月': 'इस महीने',
        '上月': 'पिछला महीना',
    }
}
